module.exports = __webpack_public_path__ + "media/src/fonts/PTRoubleSans-daa99117932d86960a9e28f2413e3566.woff2";